<template>
    <el-form label-position="left" :inline="true" style="display: flex;">
        <el-form-item label="模式:">
            <el-select v-model="playerQueryMode" placeholder="请选择查询模式" @change="selectQueryMode">
                <template v-for="i in queryMode">
                    <el-option
                        v-for="item in queryModeOptions"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                        v-if="i == item.value"
                    >
                    </el-option>
                </template>
            </el-select>
        </el-form-item>

        <el-form-item label="长id：" v-if="playerQueryMode == 'mode_long_id'">
            <el-input v-model="longId" placeholder="请输入探索者完整id"></el-input>
        </el-form-item>

        <template  v-if="playerQueryMode == 'mode_short_id'">
            <el-form-item label="短id：">
                <el-input v-model="shortId" placeholder="请输入探索者账号"></el-input>
            </el-form-item>
            <el-form-item label="服务器id：">
<!--            <el-input v-model="shortServerNumber" placeholder=""></el-input>-->
                <template>
                    <el-select v-model="shortServerNumber" filterable placeholder="请输入用户完整服务器id">
                        <el-option
                            v-for="item in shotIdServerArray"
                            :key="item.id"
                            :label="item.server_number +'-' +item.server_name"
                            :value="item.server_number">
                        </el-option>
                    </el-select>
                </template>


            </el-form-item>
        </template>

        <el-form-item label="sid:" v-if="playerQueryMode == 'mode_email'">
            <el-input v-model="queryForm.email" placeholder="请输入探索者sid"></el-input>
        </el-form-item>
        <el-form-item label="名称:" v-if="playerQueryMode == 'mode_nick'">
            <el-input v-model="queryForm.nick" placeholder="请输入探索者名称"></el-input>
        </el-form-item>
        <el-form-item label="id串:" v-if="playerQueryMode == 'mode_file_id_str'">
            <el-input style="width: 400px;" type="textarea" :autosize="{ minRows: 4}" v-model="fileIdStr" placeholder="输入id串，格式如id,id,id......"></el-input>
        </el-form-item>
        <el-form-item label="上传id文件:" v-if="playerQueryMode == 'mode_file_id'">
            <el-upload :on-success="handleResult" action="/" :on-change="handleChange" :file-list="uploadFileList">
                <el-button size="small" type="primary">上传</el-button>
            </el-upload>
        </el-form-item>

        <component-server @gameValue="getGameValue" :serverMode="'mode_game'" v-if="playerQueryMode == 'mode_email' || playerQueryMode == 'mode_nick' "></component-server>

        <el-form-item>
            <el-button size="small" type="primary" @click="getUsersData">查询用户</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import gameApi from '../service/game_api'
    import {
        mapState
    } from 'vuex';
    import actionConfirm from '../mixins/action_confirm'
    import componentServer from './component_server'
    import breadcrumb from "element-ui/packages/breadcrumb";

    export default {
        name: "component_query",
        data () {
            return {
                playerQueryMode: "mode_long_id",
                queryModeOptions: [
                    {
                        label: '长id查询',
                        value: 'mode_long_id'
                    },
                    {
                        label: '短id查询',
                        value: 'mode_short_id'
                    },
                    {
                        label: '名称查询',
                        value: 'mode_nick'
                    },
                    {
                        label: 'sid查询',
                        value: 'mode_email'
                    },
                    {
                        label: 'id串查询',
                        value: 'mode_file_id_str'
                    },
                    {
                        label: '上传id文件',
                        value: 'mode_file_id'
                    },
                ],
                queryForm: {
                    id: '',
                    email: '',
                    nick: '',
                },
                longId: '',
                shortServerNumber: '',
                shortId: '',
                shotIdServerArray:[],
                fileIdStr: '',
                fileIdData: '',

                players: [],

                uploadFileList: [],

                // 已选游戏服数据
                selectedGame: [],

            }
        },
        props: ['queryMode','queryUserId'],
        watch: {
            queryMode(n,l) {
                console.log(n)
            },

            queryUserId(n,l) {
                this.longId = this.queryUserId;
            }
        },
        created() {
            this.playerQueryMode = this.queryMode[0];

            this.shotIdServerArray = [];
            this.serverGameList.forEach(item => {
                this.shotIdServerArray.push(item);
                if (item.children){
                    for (let child of item.children) {
                        this.shotIdServerArray.push(child);
                    }
                }
            })
        },
        mixins: [actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList
            }),
        },
        methods: {
            handleResult(response, file, fileList) {
            },

            handleChange(file, fileList) {
                let self = this;
                const reader = new FileReader();
                reader.onload = function (e) {
                    const data = e.target.result;
                    self.fileIdData = data;
                }
                reader.readAsBinaryString(file.raw)
            },

            getGameValue(val) {
                this.selectedGame = val;
            },

            selectQueryMode() {
                let self = this;
                if (self.playerQueryMode == 'mode_long_id') {
                    self.queryForm.email = '';
                    self.queryForm.nick = '';
                    self.shortId = '';
                    self.shortServerNumber = '';
                    self.fileIdStr = '';
                } else if (self.playerQueryMode == 'mode_short_id') {
                    self.queryForm.email = '';
                    self.queryForm.nick = '';
                    self.longId = '';
                    self.fileIdStr = '';
                } else if (self.playerQueryMode == 'mode_nick') {
                    self.queryForm.email = '';
                    self.queryForm.id = '';
                    self.longId = '';
                    self.shortId = '';
                    self.shortServerNumber = '';
                    self.fileIdStr = '';
                } else if (self.playerQueryMode == 'mode_email') {
                    self.queryForm.nick = '';
                    self.queryForm.id = '';
                    self.longId = '';
                    self.shortId = '';
                    self.shortServerNumber = '';
                    self.fileIdStr = '';
                } else if (self.playerQueryMode == 'mode_file_id_str') {
                    self.queryForm.nick = '';
                    self.queryForm.email = '';
                    self.longId = '';
                    self.shortId = '';
                    self.shortServerNumber = '';
                }
            },
            getUsersData() {
                let self = this;
                var result = [];
                if (self.playerQueryMode == 'mode_long_id') {
                    if (self.longId == '' ){
                        self.$message({
                            type: 'error',
                            message: '请输入探索者完整id!'
                        });
                        return;
                    }
                    var serverNumber =  (( self.longId / 10000000000 ) >> 0).toString();


                    self.queryForm.id = self.longId;
                    self.serverGameList.forEach(item => {
                        if (item.server_number == serverNumber) {
                            result.push(item)
                        }
                        if (item.children){
                            for (let child of item.children) {
                                if (child.server_number == serverNumber){
                                    result.push(item);
                                    break;
                                }
                            }

                        }
                    })
                }
                else if (self.playerQueryMode == 'mode_short_id') {
                    if (self.shortId == '' ){
                        self.$message({
                            type: 'error',
                            message: '请输入探索者账号!'
                        });
                        return;
                    }
                    self.queryForm.id = (self.shortServerNumber * 10000000000) + (self.shortId >> 0);
                    self.serverGameList.forEach(item => {
                        if (item.server_number == self.shortServerNumber) {
                            result.push(item);
                            return;
                        }
                        if (item.children){
                            for (let child of item.children) {
                                if (child.server_number == self.shortServerNumber){
                                    result.push(item);
                                    break;
                                }
                            }

                        }
                    })

                }
                else if (self.playerQueryMode == 'mode_nick') {
                    if (self.queryForm.nick.length < 1  || self.queryForm.nick.length >20){
                        self.$message({
                            type: 'error',
                            message: '请输入探索者名称!'
                        });
                        return;
                    }
                    if (self.selectedGame.length > 0) {
                        self.serverGameList.forEach(item2 => {
                            let idVal = item2.id + '';
                            if (self.selectedGame.indexOf(idVal) !== -1) {
                                result.push(item2)
                            }
                        })
                    }
                }
                else if (self.playerQueryMode == 'mode_email') {
                    if (self.queryForm.email == ''){
                        self.$message({
                            type: 'error',
                            message: '请输入探索者sid!'
                        });
                        return;
                    }
                    let duplicateMachineNumbers = [];
                    self.serverGameList.forEach(item2 => {

                        let idVal = item2.id + '';
                        if (self.selectedGame.length === 0 || self.selectedGame.indexOf(idVal) !== -1) {

                            if (duplicateMachineNumbers.indexOf(item2.machine_server_number) === -1){
                                duplicateMachineNumbers.push(item2.machine_server_number);
                                result.push(item2)
                            }

                        }
                    })
                }
                else if (self.playerQueryMode == 'mode_file_id_str') {
                    self.players = [];
                    let fileIdArr = [];
                    let fileServerNumbers = [];
                    fileIdArr = self.fileIdStr.split(",");
                    fileIdArr.forEach(item => {
                        fileServerNumbers.push(item.substring(0,4))
                    })
                    fileServerNumbers.forEach((item2, index2) => {
                        self.serverGameList.forEach(item3 => {
                            if (item2 == item3.server_number) {
                                result.push({
                                    uri: item3.inner_urls.split(';')[0],
                                    server: item3.server_number,
                                    id: fileIdArr[index2],
                                })
                            }
                        })
                    })
                    self.players = self.players.concat(result);
                    self.$emit("usersData",self.players);
                }
                else if (self.playerQueryMode == 'mode_file_id') {
                    self.players = [];
                    let fileIdArr = [];
                    let fileServerNumbers = [];
                    fileIdArr = self.fileIdData.split(",");
                    fileIdArr.forEach(item => {
                        fileServerNumbers.push(item.substring(0,4))
                    })
                    fileServerNumbers.forEach((item2, index2) => {
                        self.serverGameList.forEach(item3 => {
                            if (item2 == item3.server_number) {
                                result.push({
                                    uri: item3.inner_urls.split(';')[0],
                                    server: item3.server_number,
                                    id: fileIdArr[index2],
                                })
                            }
                        })
                    })
                    self.players = self.players.concat(result);
                    self.$emit("usersData",self.players);
                }

                if (self.playerQueryMode !== 'mode_file_id_str' && self.playerQueryMode !== 'mode_file_id') {
                    self.players = [];
                    result.forEach(item => {
                        gameApi.playerList({
                            playerQueryForm: {
                                uri: item.inner_urls.split(';')[0],
                                serverId: item.server_number,
                                userId: self.queryForm.id,
                                email: self.queryForm.email,
                                nick: self.queryForm.nick
                            },
                            token: this.token
                        }).then(res => {
                            let resList = res.content.list;
                            resList.forEach(resItem => {
                                resItem.uri = item.inner_urls.split(';')[0];
                                this.serverWorldList.forEach(worldItem => {
                                    if (item.world_id == worldItem.id) {
                                        resItem.worldUri = worldItem.inner_urls.split(';')[0];
                                    }
                                })
                            })
                            self.players = self.players.concat(res.content.list);
                            self.$emit("usersData",self.players);
                        })
                    })
                }

            },
        },
        components: {
            componentServer
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/component_query.vue